/**
 * Join class names, dropping anything falsy.
 *
 * Four lines rather than `clsx`, because the runtime dependency list on this
 * surface is `react`, `react-dom` and `@pokpok/astryx` and that is the whole
 * list — the perf budget is the binding constraint here, and a guest's phone
 * pays for every byte in the critical path.
 */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
